import { Inject, Injectable } from '@angular/core';
import MatomoTracker from '@datapunt/matomo-tracker-js';
import { TrackEventParams } from '@datapunt/matomo-tracker-js/es/types';

@Injectable({
  providedIn: 'root',
})
export class MatomoService {
  private _tracker: MatomoTracker;

  private _trackerSiteId: number | undefined;

  private get tracker(): MatomoTracker | null {
    const siteId = (window as any).matomoSiteId;
    if (!siteId) {
      return null;
    }
    if (!this._tracker) {
      this._trackerSiteId = siteId;
      this._tracker = new MatomoTracker({
        urlBase: 'https://wd1.urchinsys.com',
        siteId,
        disabled: false,
        heartBeat: {
          active: true,
          seconds: 10,
        },
        linkTracking: false,
        configurations: {
          disableCookies: true,
          setSecureCookie: true,
          setRequestMethod: 'POST',
        },
      });
    } else if (this._trackerSiteId !== siteId) {
      // MatomoTracker only pushes setSiteId into window._paq on the very first
      // initialization per page load; if the tracker was created before the real
      // siteId from config was available, later `new MatomoTracker(...)` calls are
      // silently no-ops. Push it directly so requests always use the current config value.
      this._trackerSiteId = siteId;
      this._tracker.pushInstruction('setSiteId', siteId);
    }
    return this._tracker;
  }

  constructor(@Inject('env') private env) {}

  trackPageView(title: string): void {
    this.tracker?.trackPageView({
      documentTitle: title,
    });
  }

  trackEvent(params: TrackEventParams): void {
    this.tracker?.trackEvent(params);
  }

  setUserId(userId: string): void {
    this.tracker?.pushInstruction('setUserId', userId);
  }

  setCustomVariable(index: number, name: string, value: string, scope: string = 'visit'): void {
    this.tracker?.pushInstruction('setCustomVariable', index, name, value, scope);
  }

  public sendNotificationEvent(type: string, message: string): void {
    this.trackEvent({
      category: `Notification type: ${type}`,
      action: message,
    });
  }
}
